import { OrgUnitDto } from "core/models/orgUnit";
import { TenantProviderDto } from "core/models/tenantProvider";
import {
  AppointmentTypeTGArgs,
  AppointmentTypeTGDto
} from "modules/booking/models";
import queryString from "query-string";

import { AxiosInstance } from "@bps/http-client";

export class TenantGateway {
  constructor(private api: AxiosInstance) {}
  public getOrgUnits = async (): Promise<OrgUnitDto[]> =>
    (await this.api.get<OrgUnitDto[]>("client/orgUnit")).data;

  public getTenantProviders = async (): Promise<TenantProviderDto[]> =>
    (await this.api.get<TenantProviderDto[]>("client/provider")).data;

  public getAppointmentTypesTG = async (
    args?: AppointmentTypeTGArgs
  ): Promise<AppointmentTypeTGDto[]> => {
    const { stringify } = queryString;
    return (
      await this.api.get<AppointmentTypeTGDto[]>(
        `appointmentTypes?${stringify(args!)}`
      )
    ).data;
  };
}
